import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';
import type { PreviouslyLicensedDTO } from 'app/domain';

class PreviouslyLicensedService {
  readonly #httpClient: Axios;
  readonly #baseUrl: string;

  constructor(httpClient: Axios) {
    this.#httpClient = httpClient;
    this.#baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.previouslyLicensed}`;
  }

  async get(assetIds: readonly string[]): Promise<PreviouslyLicensedDTO> {
    const response = await this.#httpClient.get<PreviouslyLicensedDTO>(
      this.#baseUrl,
      {
        params: { assetIds: assetIds.join(',') },
      }
    );

    return response.data;
  }
}

export default PreviouslyLicensedService;
